import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RouteStatusScreen from './components/RouteStatusScreen';

export default function NavigatorScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/digital-media/navigator', { replace: true });
  }, [navigate]);

  return (
    <RouteStatusScreen
      kind="redirect"
      title="Открываем навигатор"
      description="Перенаправляем к поиску по материалам."
      activeRoute="navigator"
      hasMiniPlayer
    />
  );
}
